/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationCapacities200ResponseOneOf
 */
export interface GetReservationCapacities200ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetReservationCapacities200ResponseOneOf
     */
    type: GetReservationCapacities200ResponseOneOfTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetReservationCapacities200ResponseOneOf
     */
    size: number;
    /**
     * 
     * @type {string}
     * @memberof GetReservationCapacities200ResponseOneOf
     */
    sizeType: GetReservationCapacities200ResponseOneOfSizeTypeEnum;
}


/**
 * @export
 */
export const GetReservationCapacities200ResponseOneOfTypeEnum = {
    All: 'ALL'
} as const;
export type GetReservationCapacities200ResponseOneOfTypeEnum = typeof GetReservationCapacities200ResponseOneOfTypeEnum[keyof typeof GetReservationCapacities200ResponseOneOfTypeEnum];

/**
 * @export
 */
export const GetReservationCapacities200ResponseOneOfSizeTypeEnum = {
    Percentage: 'percentage',
    People: 'people'
} as const;
export type GetReservationCapacities200ResponseOneOfSizeTypeEnum = typeof GetReservationCapacities200ResponseOneOfSizeTypeEnum[keyof typeof GetReservationCapacities200ResponseOneOfSizeTypeEnum];


/**
 * Check if a given object implements the GetReservationCapacities200ResponseOneOf interface.
 */
export function instanceOfGetReservationCapacities200ResponseOneOf(value: object): value is GetReservationCapacities200ResponseOneOf {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('sizeType' in value) || value['sizeType'] === undefined) return false;
    return true;
}

export function GetReservationCapacities200ResponseOneOfFromJSON(json: any): GetReservationCapacities200ResponseOneOf {
    return GetReservationCapacities200ResponseOneOfFromJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationCapacities200ResponseOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'size': json['size'],
        'sizeType': json['sizeType'],
    };
}

export function GetReservationCapacities200ResponseOneOfToJSON(json: any): GetReservationCapacities200ResponseOneOf {
    return GetReservationCapacities200ResponseOneOfToJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseOneOfToJSONTyped(value?: GetReservationCapacities200ResponseOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'size': value['size'],
        'sizeType': value['sizeType'],
    };
}

